const ConsultingData = [{
        id: "4c",
        category: "컨설팅",
        title: "LX판토스",
        body: `
        LX판토스의 기존 포워딩 시스템을 최신을 시스템으로 업그레이드 하는 프로젝트에서 기술적인 스페셜리스트 역할을 하였습니다.
        \n\n
        구체적으로 배치와 관련한 다양한 요건을 충족할 수 있는 인프라 및 소프트웨어를 작성하였습니다.
        `,
        stack: "- spring boot, spring batch, redis, aws 등 백엔드 기술",
        hashtag: ["#백엔드", "#spring", "#인프라", ],
        img: "./images/1_consulting/04.PNG",
        logo: "./images/1_consulting/04.PNG",
        alt: "LX판토스"
    },
    {
        id: "3c",
        category: "컨설팅",
        title: "LG전자",
        body: `
        LG전자 내부 시스템을 최신의 기술 트렌드에 맞게 적용하여 경량화하는 프로젝트였습니다.
        \n\n
        주요한 역할은 SWA/AA 역할을 수행했으며 프로젝트의 뼈대가 되는 아키텍처를 설계하고 구성하였습니다.
        `,
        stack: "- spring boot, spring batch, redis, aws 등 백엔드 기술",
        hashtag: ["#백엔드", "#spring", ],
        img: "./images/1_consulting/03.PNG",
        logo: "./images/1_consulting/03.PNG",
        alt: "LG전자"
    },
    {
        id: "2c",
        category: "컨설팅",
        title: "신한카드",
        body: `
        빅데이터 및 인공지능 분석 환경을 구축하였습니다.
        `,
        stack: `
        - 하둡 클러스터 구축 / 분석 환경 구성 / sql 변환 프로그램 작성 / CI / CD 구축 \n
        - 인공지능: python/tensorflow
        `,
        hashtag: ["#인공지능", "#데이터분석", "#인프라", "#python", "#스파크", "#하둡"],
        img: "./images/1_consulting/02.PNG",
        logo: "./images/1_consulting/02.PNG",
        alt: "신한카드"
    },
    {
        id: "1c",
        category: "컨설팅",
        title: "SK 하이닉스",
        body: `
        고성능 GPU 클러스터링 하드웨어 기반의 인공지능 분석 인프라를 구축하고 인공지능을 활용하려는 고객을 대상으로 실무 기반의 인공지능 분석 교육도 진행하였습니다.
        `,
        stack: `
        - 가상 인프라 구축 / 하둡 클러스터 구축 / 분석 환경 제공\n
        - 인공지능: tensorflow, keras의 데이터 모델링 가이드
        `,
        hashtag: ["#인공지능", "#데이터분석", "#인프라", "#하둡", "#스파크", "#도커"],
        img: "./images/1_consulting/01.PNG",
        logo: "./images/1_consulting/01.PNG",
        alt: "sk하이닉스"
    },
]

export default ConsultingData;